import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "divider",
  "use": "divider-usage",
  "viewBox": "0 0 92.98 6.18",
  "content": "<symbol viewBox=\"0 0 92.98 6.18\" id=\"divider\"><path class=\"cls-1\" d=\"M93 6.18a8.29 8.29 0 0 1-5.8-2.31 6.45 6.45 0 0 0-9.08 0 8.29 8.29 0 0 1-5.79 2.31 8.29 8.29 0 0 1-5.79-2.31 6.44 6.44 0 0 0-9.07 0 8.29 8.29 0 0 1-5.79 2.31 8.29 8.29 0 0 1-5.79-2.31 6.44 6.44 0 0 0-9.07 0A8.29 8.29 0 0 1 31 6.18a8.29 8.29 0 0 1-5.79-2.31 6.44 6.44 0 0 0-9.07 0 8.29 8.29 0 0 1-5.79 2.31 8.29 8.29 0 0 1-5.81-2.31A6.36 6.36 0 0 0 0 2V0a8.29 8.29 0 0 1 5.79 2.31 6.36 6.36 0 0 0 4.54 1.87 6.36 6.36 0 0 0 4.54-1.87 8.41 8.41 0 0 1 11.59 0A6.36 6.36 0 0 0 31 4.18a6.36 6.36 0 0 0 4.54-1.87 8.42 8.42 0 0 1 11.59 0 6.36 6.36 0 0 0 4.54 1.87 6.36 6.36 0 0 0 4.54-1.87 8.42 8.42 0 0 1 11.59 0 6.36 6.36 0 0 0 4.54 1.87 6.36 6.36 0 0 0 4.54-1.87 8.42 8.42 0 0 1 11.59 0A6.36 6.36 0 0 0 93 4.18z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./application/components/dumb/icon/src/divider.svg
// module id = 159
// module chunks = 0